export default __webpack_public_path__ + "static/media/financial_color.29e9b547.svg";